import styled from "@yb/styled-px2rem";
import CompareBox from "./CompareBox";

const Stack = styled.ul`
	display: flex;
	font-size: 15px;
	line-height: 1;

	li:not(:first-child) {
		position: relative;
		padding-left: 10px;
		margin-left: 10px;

		&:before {
			position: absolute;
			top: 50%;
			left: 0;
			width: 1px;
			height: 10px;
			background-color: var(--line-color);
			transform: translateY(-50%);
			content: "";
		}
	}
`;

const StackItem = styled.li`
	font-size: 15px;
	em {
		margin-left: 5px;
		font-weight: bold;
		color: #222;
	}
`;

const SpaceLine = styled.hr`
	width: 100%;
	height: 10px;
	margin: 0;
	border: 0;
	background: var(--disabled-color);
`;

const SpaceBorderLine = styled.hr`
	width: 100%;
	height: 10px;
	margin: 0;
	border-top: 1px solid var(--line-color);
	border-bottom: 1px solid var(--line-color);
	border-left: 0;
	border-right: 0;
	background: var(--disabled-color);
`;

const FixedTop = styled.div`
	position: sticky;
	top: 0;
	display: flex;
	padding: 10px 15px;
	min-height: 60px;
	border-bottom: 1px solid var(--line-color);
	background-color: #fff;
	z-index: 15;
	align-items: center;
	transition: top 0.5s ease-out 0s;
`;

const FloatingBottomWrap = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 1;
	width: 100%;
`;

const Area = styled.div`
	&:after {
		display: block;
		width: 100%;
		height: 10px;
		margin: 0;
		border-top: 1px solid var(--line-color);
		border-bottom: 1px solid var(--line-color);
		border-left: 0;
		border-right: 0;
		background: var(--disabled-color);
		content: "";
	}
`;

export {Stack, StackItem, CompareBox, SpaceLine, FixedTop, FloatingBottomWrap, SpaceBorderLine, Area};
export {default as Flex} from "./Flex";
